import React, { useEffect, useState } from "react";
import { Text } from "@mantine/core";

const TriggerCounter: React.FC = () => {
  const [count, setCount] = useState(545445); 

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => prev + Math.floor(Math.random() * 5) + 1);
    }, 200); 

    return () => clearInterval(interval);
  }, []);

  return (
    <Text ta="center" mt="lg" c="gray.5" fz="sm" fs="italic">
      ...and {count.toLocaleString()} more
    </Text>
  );
};

export default TriggerCounter;
